// 固定资产变更流程 | vuex store
// Author Liang Gangqiang
// Date 2026-09-07

import * as model from "@/model/em/asset/EmArchFixedAssetChangeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    return Object.assign({}, paginationFilter, model.filter);
}

export default newEntityStoreHelper(() => new model.EmArchFixedAssetChange(), newFilter)
    .withStates({
        // spec D13：复用 em-archive 的 env 变量，不新增 VUE_APP_* （否则要改 16 份 .env*）
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
        // ⚠ 必须指向业务侧的 /emArchFixedAssetChange/complete-feedback，
        //   而不是基类 EmBaseWorkflowCommonResource 的 /emArchFixedAssetChange/workflow/complete-feedback：
        //   基类那条映射挂在包级可见方法上，跨包子类的同名方法不构成 override，两条路径都会注册，
        //   但基类那条只做 updateStatusDirect —— 指错了「当前处理人维护 / 档案回写 / 邮件通知」
        //   整段业务逻辑都不会执行，而且不报错。
        //   正确先例：EmMaMaintenanceWoStore / SithMesPrdZpp1Store；
        //   出门证 / 工具刀具 / PPE 的 store 指的是错的那条（既有隐患，别照抄）。
        callbackApi: process.env.VUE_APP_EM_ARCHIVE_URL + '/emArchFixedAssetChange/complete-feedback',
        processDefinitionKey: "em_arch_fixed_asset_change",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
